import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M7 18h2V6H7zm4 4h2V2h-2zm-8-8h2v-4H3zm12 4h2V6h-2zm4-8v4h2v-4z"></path>
  </>,
  'GraphicEq',
)
